import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/roll_probs_3d.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/masters_2024/three_dice.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_blitz.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_custom.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_finkel.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/buttons/board_masters.svg");
